<template>
  <div class="information">
    <template v-if="tableItems.length">
      <div class="information__search">
        <BaseInput
          v-model="searchValue"
          placeholder="Поиск по всем параметрам"
          isSearch
          @enter="onSearch"
        />
      </div>

      <AppTable
        :fields="tableFields"
        :items="tableItems"
        class="information__table"
        @sort="onSortTable"
      >
        <template #title="{ title, id }">
          <BaseLink :href="`/events/${id}`">
            {{ title }}
          </BaseLink>
        </template>

        <template #playground="{ playground }">
          <BaseLink :href="`/fields/${playground.id}`">
            {{ playground.title }}
          </BaseLink>
        </template>

        <template #createdBy="{ createdBy }">
          <BaseLink :href="`/user/${createdBy.id}`">
            {{ createdBy.name ?? '' }} {{ createdBy.surname ?? '' }}
          </BaseLink>
        </template>
      </AppTable>

      <div class="information__pag-wrapper">
        <AppPagination
          v-if="(paginationTotal / paginationPerPage) > 1"
          v-model="paginationCurrent"
          :totalRows="paginationTotal"
          :perPage="paginationPerPage"
        />
      </div>
    </template>

    <p v-else class="h2">Список событий пуст.</p>
  </div>
</template>

<script>
import BaseInput from '@/components/Base/BaseInput'
import AppPagination from '@/components/Base/AppPagination'
import AppTable from '@/components/AppTable'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'AppList',
  components: {
    BaseInput,
    BaseLink,
    AppTable,
    AppPagination
  },
  data () {
    return {
      tableFields: [
        { key: 'title', label: 'Название события', sortable: true, slot: true },
        { key: 'playground', label: 'Название поля', sortable: true, slot: true },
        { key: 'address', label: 'Адрес', sortable: true },
        { key: 'createdBy', label: 'Создатель', sortable: true, slot: true },
        { key: 'start', label: 'Начало', sortable: true },
        { key: 'status', label: 'Статус', sortable: true },
        { key: 'type', label: 'Тип', sortable: true }
      ],
      tableItems: [],
      searchValue: '',
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 10,
      order: 'DESC',
      sort: 'id'
    }
  },
  computed: {
    /**
     * Тело запроса
     */
    requestBody () {
      return {
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent,
        searchBy: this.searchValue,
        sort: this.sort,
        order: this.order
      }
    }
  },
  watch: {
    /**
     * Отслеживанию изменение св-ва и подтягиваю новые данные таблицы
     */
    paginationCurrent: 'fetchEvents'
  },
  async created () {
    await this.fetchEvents()
  },
  methods: {
    async fetchEvents () {
      try {
        const { data } = await this.$api.events.list(this.requestBody)
        /* Записал общее колво событий */
        this.paginationTotal = data.pages * this.paginationPerPage
        const list = data?.list ?? []

        this.tableItems = list.map(item => {
          const title = item.title ?? ''
          const playground = item?.playground ?? {}
          const address = item?.address ?? ''
          const createdBy = item?.createdBy ?? {}
          const start = item?.start ?? ''
          const status = item?.status ?? ''
          const type = item?.type ?? ''

          return {
            id: item?.id,
            title,
            playground,
            address,
            createdBy,
            start,
            status,
            type
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * Записал новое значение поиска
     */
    async onSearch () {
      await this.fetchEvents()
    },
    /**
     * Записал новые значения сортировки
     */
    onSortTable (event) {
      this.sort = event.key
      this.order = event.by.toUpperCase()
      this.fetchEvents()
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  &__search {
    width: 650px;
    margin: 20px 0 40px;
  }

  &__pag-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
